import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { LocaleContext } from '../../../../contexts/LocaleContext'
import DraftStatusBadge from '../../../Shared/DraftStatusBadge'

// Shown only while internally_approved, never once truly (client-)approved.
// internally_approved can still be pending a client step the influencer has
// no visibility into, so "safe to post" must never be implied before the
// real final approval - reusing this warning, or the same unqualified
// "approved!" headline, for both states would do exactly that.
const PENDING_CLIENT_COPY = {
  en: {
    heading: 'Approved by Reachbird - awaiting the client\'s final sign-off.',
    warning: 'Important: The content may only be published after the client\'s final approval has been received. It must not be posted before then.',
  },
  de: {
    heading: 'Von Reachbird freigegeben - die finale Freigabe des Kunden steht noch aus.',
    warning: 'Wichtig: Der Content darf erst nach der finalen Freigabe des Kunden veröffentlicht werden. Er darf vorher nicht gepostet werden.',
  },
}

const FINAL_COPY = {
  en: { heading: 'Fully approved - you\'re good to publish!' },
  de: { heading: 'Vollständig freigegeben - du kannst jetzt veröffentlichen!' },
}

export default observer(function ApprovedState({ action, role = 'influencer' }) {
  const { localeState } = useContext(LocaleContext)
  const version = action.action_draft.latestVersion
  const asset = version?.draft_assets[0]
  const isFinal = action.action_draft.draft_status === 'approved'
  const copy = (isFinal ? FINAL_COPY : PENDING_CLIENT_COPY)[localeState.locale] || (isFinal ? FINAL_COPY : PENDING_CLIENT_COPY).en

  return (
    <div className="flex flex-col items-center">
      <div className="my-5 p-3 rounded-lg bg-white dark:bg-rb-dark-mode flex justify-between items-center w-[650px] border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter">
        <h2 className="font-bold text-lg dark:text-white">{action.name}</h2>
        <DraftStatusBadge draftStatus={action.action_draft.draft_status} role={role} />
      </div>

      <div className="w-[650px] p-5 rounded-lg bg-white dark:bg-rb-dark-mode border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter flex flex-col items-center">
        {asset && (
          ['mp4', 'mov'].includes(asset.file_type) ? (
            <video src={asset.url} controls className="max-h-80 rounded-lg mb-4" />
          ) : (
            <img src={asset.url} className="max-h-80 rounded-lg mb-4" />
          )
        )}
        <p className="text-center font-bold text-rb-green mb-3">{copy.heading}</p>
        {!isFinal && <p className="text-center font-bold text-red-600">{copy.warning}</p>}
      </div>
    </div>
  )
})
